import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes, faEye, faEyeSlash, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import '../AdminCommon.css';
import './Register.css';

export default function Register({ onUserCreated }) {
    const [nombre, setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [rol, setRol] = useState('mesero');
    const [contrasena, setContrasena] = useState('');
    const [cargando, setCargando] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    const resetForm = () => {
        setNombre('');
        setEmail('');
        setRol('mesero');
        setContrasena('');
        setShowPassword(false);
    };

    const toggleModal = () => {
        if (modalOpen) {
            resetForm();
        }
        setModalOpen(!modalOpen);
    };

    const crearUsuario = async (e) => {
        if (e) e.preventDefault();

        if (!nombre.trim() || !email.trim() || !contrasena) {
            toast.warn('Por favor, completa todos los campos requeridos.');
            return;
        }

        setCargando(true);
        try {
            const formData = new FormData();
            formData.append('nombre', nombre.trim());
            formData.append('email', email.trim());
            formData.append('rol', rol);
            formData.append('contrasena', contrasena);

            const response = await fetch(`${baseURL}/registroPost.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();
            if (data.mensaje) {
                toast.success(data.mensaje);
                resetForm();
                setModalOpen(false);
                if (typeof onUserCreated === 'function') {
                    onUserCreated();
                } else {
                    window.location.reload();
                }
            } else if (data.error) {
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error al registrar usuario:', error);
            toast.error('Error de conexión al registrar usuario');
        } finally {
            setCargando(false);
        }
    };

    return (
        <div>
            <button onClick={toggleModal} className="adminBtnPrimary" title="Registrar un nuevo miembro del equipo">
                <FontAwesomeIcon icon={faPlus} /> Agregar usuario
            </button>

            {modalOpen && (
                <div className="adminModalOverlay" onClick={toggleModal}>
                    <div className="adminModalContent modalSmallSimple" onClick={(e) => e.stopPropagation()}>
                        <div className="adminModalHeader">
                            <h3><FontAwesomeIcon icon={faUserPlus} /> Registrar Usuario</h3>
                            <button type="button" className="adminModalClose" onClick={toggleModal}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <form onSubmit={crearUsuario}>
                            <div className="adminModalBody">
                                <div className="adminFormField">
                                    <label>Nombre Completo (Obligatorio):</label>
                                    <input
                                        type="text"
                                        placeholder="Ej: Carlos Gómez"
                                        value={nombre}
                                        onChange={(e) => setNombre(e.target.value)}
                                        required
                                        autoFocus
                                    />
                                </div>

                                <div className="adminFormField">
                                    <label>Correo Electrónico (Obligatorio):</label>
                                    <input
                                        type="email"
                                        placeholder="carlos@restaurante.com"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>

                                <div className="adminFormField">
                                    <label>Contraseña (Obligatorio):</label>
                                    <div className="passwordInputContainer">
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            placeholder="Ingresa una contraseña segura"
                                            value={contrasena}
                                            onChange={(e) => setContrasena(e.target.value)}
                                            required
                                        />
                                        <button
                                            type="button"
                                            className="btnTogglePassword"
                                            onClick={() => setShowPassword(!showPassword)}
                                            title={showPassword ? 'Ocultar contraseña' : 'Ver contraseña'}
                                        >
                                            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                        </button>
                                    </div>
                                </div>

                                <div className="adminFormField">
                                    <label>Rol y Nivel de Acceso (Obligatorio):</label>
                                    <select
                                        value={rol}
                                        onChange={(e) => setRol(e.target.value)}
                                        required
                                    >
                                        <option value="admin">Administrador (Acceso total al sistema)</option>
                                        <option value="mesero">Mesero (Gestión de pedidos y mesas)</option>
                                        <option value="cocinero">Cocinero (Panel de cocina KDS)</option>
                                        <option value="cajero">Cajero (Punto de Venta POS y cobros)</option>
                                        <option value="usuario">Usuario / Cliente</option>
                                    </select>
                                </div>
                            </div>

                            <div className="adminModalFooter">
                                <button type="button" className="adminBtnSecondary" onClick={toggleModal} disabled={cargando}>
                                    Cancelar
                                </button>
                                <button type="submit" className="adminBtnPrimary" disabled={cargando}>
                                    {cargando ? 'Registrando...' : 'Registrar Usuario'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
